export const WS_URL = {

    // Main websocket used for communication with the server
    UNSECURED_ICA_WEBSOCKET: "ws://localhost/api/ica-ws",
    SECURED_ICA_WEBSOCKET: "wss://localhost/api/ica-ws",

    // Websocket used for communication with Plugin Manager. Used for enrolment via MDE/Omnikey/MSO300/etc.
    UNSECURED_PLUGIN_MANAGER_WEBSOCKET: "ws://localhost:83",
    SECURED_PLUGIN_MANAGER_WEBSOCKET: "ws://localhost:83", // wss://localhost:84 (wss is not working on HTTPS. Needs further investigation. ws does work.)
    LOCALHOST_WEBSOCKET_NAME: "localhost",
    SECURE_WEBSOCKET_PORT: '443',
    UNSECURE_WEBSOCKET_PORT: '82'
}

// Retries
export const WS_RETRIES = {
    MAX_RETRY: 3, // Max attempts allowed to connect on websocket. Once we hit the max, we stop trying. Move off the view and back will reset.
    TIMEOUT_DEFAULT: 2000, // Default timeout value. We will reset to this value upon successful connection.
    TIMEOUT_INCREASE: 1000 // Increase the delay between retries each time it fails.
}

// Count Status meanings
export const WS_COUNT_STATES = {
    COUNT_STATUS_FOUND: 0, // Includes count of total devices found
    COUNT_STATUS_INSTALLED: 1, // Includes count of total devices installed
    COUNT_STATUS_UNSUPPORTED: 2, // Includes count of total devices unsupported
    COUNT_STATUS_PWD_AUTO_UPDATED: 3, // Just indicates that the password was auto-updated. 0=No changes; 1=Changes made
}

// Request Message Types
export const TYPE_REQ_ENGINE_STATUS = 0;
export const TYPE_REQ_START_ENGINE = 1;
export const TYPE_REQ_STOP_ENGINE = 2;
export const TYPE_REQ_FULL_SYNC = 3;
export const TYPE_REQ_UPLOADER_STATUS = 4;
export const TYPE_REQ_INSTALL = 5;
export const TYPE_REQ_REPLACE_TERMINAL = 6;
export const TYPE_REQ_REPLACE_CONTROLLER = 7;
export const TYPE_REQ_UNINSTALL_TERMINAL = 8;
export const TYPE_REQ_UNINSTALL_CONTROLLER = 9;
export const TYPE_REQ_PING = 10;
export const TYPE_REQ_TERMINAL_STATUS = 11;
export const TYPE_REQ_INJECT_PAC = 12;
export const TYPE_REQ_DOOR_STATUS = 13;
export const TYPE_REQ_HARDWARE_STATUS = 14;
export const TYPE_REQ_LIFT_RELAY_STATUS = 15;
export const TYPE_REQ_LIFT_RELAY_DRIVE = 16;
export const TYPE_REQ_FIRMWARE_UPGRADE = 17;
export const TYPE_REQ_USER_ID_LIST = 18;

// Reply Message Types
export const TYPE_REPLY_COUNT_STATUS = 0;
export const TYPE_REPLY_DEVICE_STATUS = 1;
export const TYPE_REPLY_TASK_STATUS = 2;
export const TYPE_REPLY_PING_STATUS = 3;

// Task Status meanings
export const TASK_STATUS_STARTED = 0;
export const TASK_STATUS_PROGRESS = 1; // Includes some progress messages
export const TASK_STATUS_ERROR = 2;
export const TASK_STATUS_FAILED = 3;
export const TASK_STATUS_COMPLETED = 4;
export const TASK_STATUS_STOPPED = 5;
export const TASK_STATUS_UPLOADING = 6; // Uploading in progress
export const TASK_STATUS_SCHEDULED = 7;
export const TASK_STATUS_BATCH_START = 8; // Batch process has started
export const TASK_STATUS_BATCH_END = 9; // Batch process has completed
export const TASK_STATUS_FATAL_ERROR = 10;
export const TASK_STATUS_CONSTRAINT_FAILED = 11; // Validation failed
export const TASK_STATUS_UPLOAD_STATUS_IMPROX = 12; // Total in queue for Improx
export const TASK_STATUS_UPLOAD_STATUS_BIO = 13; // Total in queue for Biometrics

// Device Status meanings
export const DEVICE_STATUS_ONLINE = 0; // ICMP ping only. Can't reach the app.
export const DEVICE_STATUS_OFFLINE = 1;
export const DEVICE_STATUS_BUSY = 2;
export const DEVICE_STATUS_UPLOADING = 3;
export const DEVICE_STATUS_UNKNOWN = 4;
export const DEVICE_STATUS_NEW = 5; // Used for RB/IBR. In this state we can't talk to the device.
export const DEVICE_STATUS_EMERGENCY_MODE = 6;
export const DEVICE_STATUS_LOCKDOWN_MODE = 7;
export const DEVICE_STATUS_ONLINE_APP = 8; // ICMP ping & app on device is reachable.

// Ping Status meanings
export const PING_STATUS_RS485 = 0; // Reporting on status of an RS485 scan
export const PING_STATUS_ETHERNET = 1; // Reporting on status of a Network scan
export const PING_STATUS_RS485_AND_ETHERNET = 2; // Reporting on status of both an RS485 scan + Network scan

// Websocket response will contain key/value pairs
export const KEY_REPLY_MESSAGE_TYPE = '#replyMessageType';
export const KEY_STATUS_TYPE = '#statusType';
export const KEY_STATUS = '#status';
export const KEY_COUNT = '#count';
export const KEY_MESSAGE = '#message';
export const KEY_CONSTRAINT_VIOLATION_EX = '#constraintViolationEx';
export const KEY_DATE_TIME = "#dateTime";
export const KEY_SOURCE = "#source";
export const KEY_MESSAGE_PRIORITY = "#priority";
export const KEY_MESSAGE_BATCH_ID = "#batch";
export const KEY_DEV_NAME = "#devName";
export const KEY_DEV_CHANNEL = "#channel";
export const KEY_FIXED_ADDRESS = "#fixedAddress";
export const KEY_IP_ADDRESS = "#ipAddress";
export const KEY_VERSION = "#version";
export const KEY_OLD_FA = "#oldFa";
export const KEY_NEW_FA = "#newFa";
export const KEY_BATCH_FIXED_ADDRESSES = "#batchFixedAddresses";
export const KEY_SET_BEGIN = "#setBegin";
export const KEY_SET_END = "#setEnd";
export const KEY_ITEM_BEGIN = "#itemBegin";
export const KEY_ITEM_END = "#itemEnd";
export const KEY_PAC_CODE = "#pacCode";//decimal
export const KEY_MAC_ADDRESS = "#macAddress";
export const KEY_DISCOVERY_ID = "#discoveryId"; // Integer
export const KEY_USERNAME = "#username";
export const KEY_PASSWORD = "#password";
export const KEY_SYNC_TYPE = "#syncType";
export const KEY_SLA = "#sla";
export const KEY_LIFT_ID = "#liftId";
export const KEY_RELAY_INDEX = "#relayIndex";
export const KEY_SITE_ID = "#siteId";
export const KEY_RELAY_STATES = "#relayStates";
export const KEY_INPUT_STATES = "#inputStates";
export const KEY_DIP_SWITCH_STATES = "#dipSwitchStates";
export const KEY_DOMAIN_ID = "#domainId";
export const KEY_UT_CATEGORY = "#utCategory";
export const KEY_DEV_FA_SET = "#devFaSet"; // A collection of fixed addresses
export const KEY_DEV_QUEUE_UP = "#devQUp"; // Uploader queue size
export const KEY_DEV_QUEUE_DOWN = "#devQDown"; // Downloader queue size
